;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.HelpGameGuidelines = Marionette.ItemView.extend({
		template: JST.helpGameGuidelines,
		tagName: 'div',
		initialize: function () {
			this.model.appendScript( this );
		},
		showContent: function () {
			var property = this.model.property;
			var title = EXPORTS.GLOBAL_DATA[property]['items'].length ? EXPORTS.GLOBAL_DATA[property]['items'][0].title : 'Title example',
				text  = EXPORTS.GLOBAL_DATA[property]['items'].length ? EXPORTS.GLOBAL_DATA[property]['items'][0].text : 'Lorem ipsum dolor sit amet ...';

			this.$el.html(
				this.template({
					title:   title,
					content: text
				})
			);
		}
	});

}(window, APP, Backbone, Marionette, $, _));